import React from 'react'
import { Link } from 'react-router-dom';
import "./back.scss";

export default function Back() {
  return (
    <div className='back'>
        <Link to="/" >
            <img src="https://cdn-icons-png.flaticon.com/512/17/17699.png" alt="" />
        </Link>
    </div>
  )
}
